import { Navigate } from 'react-router-dom';
import { isTokenValid, clearSession } from '../../utils/authUtils';

/**
 * Gates the admin shell. Renders children only when a present, non-expired token
 * exists; otherwise clears any stale/forged session state and redirects to
 * /login. This is a UX gate, not a security boundary — the backend enforces
 * authorization on every request. Its job is to stop the admin UI from loading
 * for anyone who isn't (or is no longer) authenticated.
 */
export default function ProtectedRoute({ children }) {
  if (!isTokenValid()) {
    clearSession();
    return <Navigate to="/login" replace />;
  }
  return children;
}
